import { useEffect, useRef } from 'react';
import { useRefundAmount } from './useRefundAmount';
import { animateRefundAmount } from '../components/income-tax/page-sections/hero-section-new/refund-strip/utils';

export const useRefundAnimation = (fallbackAmount: number = 418.26) => {
  const refund = useRefundAmount(fallbackAmount);
  const refundTextRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (refundTextRef.current) {
        animateRefundAmount(refundTextRef.current, refund.refund_amount);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [refund.refund_amount]);

  return { refundTextRef, refundAmount: refund.refund_amount };
};
